import { jsxs as g, jsx as S } from "react/jsx-runtime";
import w, { forwardRef as m } from "react";
import { c as h } from "./index.CWkFp9WS.js";
import { O as W } from "./ODSBox.Dx8RRD-O.js";
import { O as p } from "./ODSColumn.B8Qu83P2.js";
import '../assets/ODSSwitchIcon.css';function x(d) {
  const {
    defaultChecked: n,
    checked: t,
    onCheckedChange: c,
    disabled: o,
    readOnly: l
  } = d, r = w.useRef(null), [D, e] = w.useState(
    () => n ?? !1
  ), O = t != null && c != null, s = t ?? D, i = w.useMemo(() => s ? "selected" : "unselected", [s]), a = w.useCallback(() => {
    o || l || (O || e((I) => !I), c == null || c(!s));
  }, [o, l, O, c, s]);
  return w.useEffect(() => {
    if (!r.current) return;
    const I = r.current;
    return I.addEventListener("change", a), () => {
      I.removeEventListener("change", a);
    };
  }, [a]), {
    inputRef: r,
    isChecked: s,
    iconSelected: i
  };
}
const k = m(({ children: d, className: n, ...t }, c) => /* @__PURE__ */ S(
  "div",
  {
    className: h("ODSSwitchIcon-InputWrapper", n),
    ref: c,
    ...t,
    children: d
  }
));
k.displayName = "ODSSwitchIconInputWrapper";
const C = m(
  (d, n) => {
    const { size: t = "large", selected: c, disabled: o, readOnly: l, className: r } = d;
    return /* @__PURE__ */ S(
      p,
      {
        className: h(
          "ODSSwitchIcon",
          `ODSSwitchIcon--size-${t}`,
          c && "ODSSwitchIcon--selected",
          o && "ODSSwitchIcon--disabled",
          l && "ODSSwitchIcon--readonly",
          r
        ),
        ref: n,
        "aria-hidden": "true",
        children: /* @__PURE__ */ S(
          p,
          {
            className: h(
              "ODSSwitchIcon-Stroke",
              c && "ODSSwitchIcon-Stroke--selected",
              o && "ODSSwitchIcon-Stroke--disabled",
              l && "ODSSwitchIcon-Stroke--readonly",
              `ODSSwitchIcon-Stroke--size-${t}`
            ),
            children: /* @__PURE__ */ S(
              p,
              {
                className: h(
                  "ODSSwitchIcon-Container",
                  `ODSSwitchIcon-Container--size-${t}`,
                  o && "ODSSwitchIcon-Container--disabled",
                  c && "ODSSwitchIcon-Container--selected",
                  l && "ODSSwitchIcon-Container--readonly"
                ),
                children: /* @__PURE__ */ S(
                  W,
                  {
                    className: h(
                      "ODSSwitchIcon-Handle",
                      o && "ODSSwitchIcon-Handle--disabled",
                      c && "ODSSwitchIcon-Handle--selected",
                      l && "ODSSwitchIcon-Handle--readonly",
                      `ODSSwitchIcon-Handle--size-${t}`
                    )
                  }
                )
              }
            )
          }
        )
      }
    );
  }
);
C.displayName = "SwitchIcon";
const z = m(
  (d, n) => {
    const {
      size: t = "large",
      defaultChecked: c,
      disabled: o,
      readOnly: l,
      className: r,
      checked: D,
      inputProps: e,
      onCheckedChange: O,
      ...s
    } = d, i = e != null && e.disabled ? e == null ? void 0 : e.disabled : o, a = e != null && e.readOnly ? e == null ? void 0 : e.readOnly : l, { inputRef: I, isChecked: f, iconSelected: y } = x({
      defaultChecked: c,
      checked: D,
      onCheckedChange: O,
      disabled: i,
      readOnly: a
    }), b = () => {
      if (n && "current" in n && n.current) {
        const u = n.current.querySelector(
          'input[type="checkbox"]'
        );
        u && !i && !a && u.click();
      }
    }, N = (u) => {
      O && O(u.target.checked);
    };
    return /* @__PURE__ */ g(
      k,
      {
        ref: n,
        className: h(
          a && "ODSSwitchIcon-InputWrapper--readonly",
          i && "ODSSwitchIcon-InputWrapper--disabled",
          "ODSSwitchIcon-Wrapper",
          r
        ),
        onClick: b,
        ...s,
        children: [
          /* @__PURE__ */ S(
            "input",
            {
              ref: I,
              type: "checkbox",
              role: "switch",
              checked: f,
              className: h(
                "ODSSwitchIcon-InputWrapper-Input",
                e == null ? void 0 : e.className
              ),
              tabIndex: 0,
              "aria-disabled": i,
              "aria-readonly": a,
              disabled: i,
              readOnly: a,
              onClick: (u) => {
                u.stopPropagation();
              },
              onChange: N,
              ...e
            }
          ),
          /* @__PURE__ */ S(
            C,
            {
              selected: y === "selected",
              size: t,
              disabled: i,
              readOnly: a
            }
          )
        ]
      }
    );
  }
);
z.displayName = "ODSSwitchIcon";
export {
  z as O
};
//# sourceMappingURL=ODSSwitchIcon.Bu7z9GAD.js.map
